import React from "react";
import {EonUiRadioButton} from "@eon-ui/eon-ui-components-react";
import styles from "./Item.module.scss"

type Props = {
    value: string | undefined;
    title: string;
    description: string;
}

export const ItemComponent: React.FC<Props> = ({
                                                           value,
                                                           title,
                                                           description,
                                                       }) => {
    return (
        <div key={value} className={styles.item}>
            <div className={styles.item__content}>
                <EonUiRadioButton
                    label={title}
                    value={value}
                />
                <p className={styles.item__desc}>
                    {description}
                </p>
            </div>
        </div>
    )
}